const BLOCK_LABELS: Record<string, string> = {
  "blocks.hero": "بانر رئيسي",
  "blocks.text": "نص",
  "blocks.image": "صورة",
  "blocks.spacer": "مسافة",
  "blocks.divider": "فاصل",
  "blocks.quick-links": "روابط سريعة",
  "blocks.editorial-card": "بطاقة تحريرية",
  "blocks.title-region": "منطقة عنوان",
  "blocks.button": "زر",
  "blocks.news": "أخبار",
  "blocks.events": "فعاليات",
  "blocks.powerbi": "Power BI",
  "blocks.embed": "تضمين",
  "blocks.document-list": "قائمة مستندات",
  "blocks.form": "نموذج",
};

interface ContentPreviewPanelProps {
  blocks?: unknown;
  layout?: unknown;
}

function blockLabel(component: string): string {
  return BLOCK_LABELS[component] ?? component;
}

export function ContentPreviewPanel({ blocks, layout }: ContentPreviewPanelProps) {
  const blockList = Array.isArray(blocks) ? blocks : [];

  return (
    <div className="space-y-3">
      {layout != null && (
        <div className="rounded-md border border-border bg-muted/20 p-2 text-xs text-muted-foreground">
          تخطيط الصفحة محفوظ
        </div>
      )}
      {blockList.length === 0 ? (
        <p className="py-4 text-center text-sm text-muted-foreground">
          لا توجد كتل محتوى
        </p>
      ) : (
        <ol className="space-y-2">
          {blockList.map((block, index) => {
            const b = block as { __component?: string; title?: string; text?: string };
            const component = b.__component ?? "unknown";
            const preview =
              b.title ?? b.text ?? blockLabel(component);
            return (
              <li
                key={index}
                className="flex items-start justify-between gap-3 rounded-md border border-border px-3 py-2 text-sm"
              >
                <span className="text-muted-foreground">{index + 1}.</span>
                <div className="flex-1 text-right">
                  <div className="font-medium">{blockLabel(component)}</div>
                  {preview && preview !== blockLabel(component) && (
                    <div className="mt-0.5 text-xs text-muted-foreground line-clamp-2">
                      {String(preview)}
                    </div>
                  )}
                </div>
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
}
